import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SelectComponent } from '@ftr/forms'
import { AnchorComponent, BreadcrumbModule, ButtonComponent, IconLegacyComponent, TooltipModule } from '@ftr/foundation'

/*
 * FTR Web App Imports
 */
import { DropdownMenuLegacyComponent } from '@ftr/menus'
import { FtrLogoComponent, HeaderLoggedOutComponent, LegacyOverflowMenuComponent, SideNavModule } from '@ftr/ui-core'

/*
 * FTR Admin App Imports
 */
import { CourtSystemLogoComponent } from '@ftr/ui-court-system'
import { AccountMenuComponent } from './account-menu/account-menu.component'
import { HeaderComponent } from './header.component'

@NgModule({
  imports: [
    AnchorComponent,
    ButtonComponent,
    CommonModule,
    CourtSystemLogoComponent,
    DropdownMenuLegacyComponent,
    FtrLogoComponent,
    IconLegacyComponent,
    LegacyOverflowMenuComponent,
    RouterModule,
    SelectComponent,
    SideNavModule,
    TooltipModule,
    HeaderLoggedOutComponent,
    BreadcrumbModule,
  ],
  declarations: [AccountMenuComponent, HeaderComponent],
  exports: [HeaderComponent, AccountMenuComponent],
})
export class HeaderModule {}
